import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getBillingReconciliationHistory,
  getBillingReconciliationHistoryBacLookup,
  updateBillingReconciliationHistoryAdjustment,
} from './billingReconciliationHistoryApi.js';

export const billingReconHistoryKeys = {
  history: ({ program, limit } = {}) => ['billingRecon', 'history', program || null, limit || null],
  historyBacLookup: ({ runId, bac, includeFinalRows, includeActions, limit, offset } = {}) => [
    'billingRecon',
    'historyBacLookup',
    runId || null,
    bac || null,
    includeFinalRows ?? null,
    includeActions ?? null,
    limit || null,
    offset || null,
  ],
};

const noRetry = { retry: false };

export const useBillingReconciliationHistory = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconHistoryKeys.history(params),
    queryFn: ({ signal }) => getBillingReconciliationHistory({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.program),
    staleTime: 30 * 1000,
    ...noRetry,
    ...options,
  });

export const useBillingReconciliationHistoryBacLookup = (params = {}, options = {}) =>
  useQuery({
    queryKey: billingReconHistoryKeys.historyBacLookup(params),
    queryFn: ({ signal }) => getBillingReconciliationHistoryBacLookup({ ...params, signal }),
    enabled: (options.enabled ?? true) && Boolean(params.runId && params.bac),
    staleTime: 30 * 1000,
    ...noRetry,
    ...options,
  });

export const useUpdateBillingReconciliationHistoryAdjustment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationHistoryAdjustment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'history'] });
    },
  });
};
